import React from 'react';
import { Paragraph, Span } from '../../../../components/typography';
import DeliveryOption from './DeliveryOption';
import { Row, Col } from '../../../../components/grid';
import TimeElement from '../../../../components/Date/Time';
import DateElement from '../../../../components/Date/DateElement';
import { createTime, createDate } from '../../../../containers/Date';
import { dateTypes } from '../../../../features/commerce/delivery/dates';
import { deliveryTypes } from '../../../../features/commerce/delivery/shared';
import ReadMore from '../../../../components/ReadMore';
import BucketDeliveryPrice from '../../../../components/commerce/Bucket/BucketDeliveryPrice';

const DeliveryDate = createDate(deliveryTypes.delivery)(dateTypes.delivery)(DateElement);
const DeliveryTime = createTime(deliveryTypes.delivery)(dateTypes.delivery)(TimeElement);

export default ({
  chosen,
  error,
  onChoose,
  hideError,
  component: DeliveryOptionComponent = DeliveryOption,
  hasOnlyPostnordItems,
  step2,
}) => (
  <DeliveryOptionComponent
    onChoose={onChoose}
    choosen={chosen}
    error={error}
    headline="Levering"
    subheadline={(
      <React.Fragment>
        {!hasOnlyPostnordItems && (
          <React.Fragment>
            <Span fontSize="13px" block bold>
              Ingen returret på ubrudte fustager
            </Span>
            <Span fontSize="12px" block paddingTop="5px">
              Vi tager gerne dit returpant i forbindelse med levering.
            </Span>
          </React.Fragment>
        )}
      </React.Fragment>
    )}
    hideError={hideError}
  >
    <Row>
      <Col xs={12} md={step2 ? 12 : 6} padding="0px 15px">
        {!hasOnlyPostnordItems && (
          <React.Fragment>
            <Paragraph grey={!chosen && error} fontSize={step2 && 13}>
              Mulighed for gratis levering.<br />
              Normalt efter 1-2 hverdage, eller vælg dato.
            </Paragraph>
            <Paragraph grey={!chosen && error} fontSize="12px" margin={step2 && '10px 0'}>
              Gratis levering ved bestilling af mindst 120-150 dåser/flasker, mindst 50 liter fadøl eller 2 kulsyreflasker.
            </Paragraph>
            <Paragraph grey={!chosen && error} fontSize="12px" margin={step2 && '10px 0'}>
              Gratis levering gælder ikke fadølsanlæg og bar samt andet lejet udstyr.
            </Paragraph>
            <ReadMore>
              <Paragraph grey={!chosen && error} fontSize="12px" margin={step2 && '10px 0'}>
                Pant i form af kasser med/uden flasker, kulsyreflasker og fustager modtages gerne i forbindelse med leveringen. Ingen returret på fyldte fustager eller andre fyldte varer.
                Ved efterfølgende aflevering af returemballage udbetales pant.
              </Paragraph>
              <Paragraph grey={!chosen && error} fontSize="12px" margin={step2 && '10px 0'}>
                Mindre ordre mod transport tillæg, læg varer i kurven og se transport omkostningerne.
                Spørgsmål til bestilling ring 43 27 00 00
              </Paragraph>
            </ReadMore>
          </React.Fragment>
        )}
        {hasOnlyPostnordItems && (
          <React.Fragment>
            <Paragraph grey={!chosen && error} fontSize={step2 && 13}>
              Levering med Post Nord 1 - 3 hverdage.
            </Paragraph>
            <Paragraph grey={!chosen && error} fontSize={step2 && 13}>
              <BucketDeliveryPrice />
            </Paragraph>
          </React.Fragment>
        )}
      </Col>
      {!hasOnlyPostnordItems && (
        <Col xs={12} md={step2 ? 12 : 6} padding="0px 15px">
          <Row greyLight={step2 && true}>
            <Col xs={12} padding="10px 15px 0 15px">
              <DeliveryDate timeComponent={<DeliveryTime />} isSmall={step2}>
                Evt. Leveringsdato
              </DeliveryDate>
            </Col>
          </Row>
        </Col>
      )}
    </Row>
  </DeliveryOptionComponent>
);
